export default __webpack_public_path__ + "static/media/xl-icon.b992277f.png";